import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "commentTrigger",
        "editorContainer"
    ]

    connect() {
    }

    showEditor() {
        if (this.hasCommentTriggerTarget) {
            this.commentTriggerTarget.classList.add("hidden")
        }
        this.editorContainerTarget.classList.remove("hidden")

        const editor = this.element.querySelector(".tiptap")
        editor.focus()
    }

    hideEditor() {
        if (this.hasCommentTriggerTarget) {
            this.commentTriggerTarget.classList.remove("hidden")
        }
        this.editorContainerTarget.classList.add("hidden")
    }
}
